import styled from 'styled-components';

export const ModalCloseButtonWrapper = styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;
`;
